module.exports = __webpack_public_path__ + "static/assets/6d912e9240790715a077d422cdbc19a5.mp3";